import { ref, computed } from 'vue'

// {
//   "assigned": false,
//   "completed": false,
//   "status": "",
//   "result": "",
//   "job": null,
//   "worker": null
// }
export interface Assignment {
  id?: number
  assigned: boolean
  completed: boolean
  job: number
  worker: number
  status: string
  [key: string]: boolean | string | number | object | string[] | null | undefined
}

export function useAssignments() {
  const assignments = ref<Assignment[]>([]) // items is now Ref<Assignment[]>
  let inFlightFetch: Promise<void> | null = null

  const getAssignments = async (): Promise<Assignment[]> => {
    const response = await fetch('/api/assignments/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Assignments')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchAssignments = async () => {
    if (inFlightFetch) {
      return inFlightFetch
    }

    inFlightFetch = (async () => {
      assignments.value = await getAssignments()
    })().finally(() => {
      inFlightFetch = null
    })

    return inFlightFetch
  }

  const assignmentKeys = computed(() => {
    const keys = assignments.value.length > 0 ? Object.keys(assignments.value[0]) : []
    // remove created and updated keys
    keys.splice(keys.indexOf('created'), 1)
    return keys
  })

  return { assignments, fetchAssignments, assignmentKeys }
}